import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import AmexImage from '../../AmexMarketingUtils/AmexImage';
import { BREAKPOINTS } from '../../AmexMarketingUtils/constants';
import ResyRewardsAppStoreButton from '../ResyRewardsAppStoreButton';
import './ResyRewardsHowItWorks.scss';

const ResyRewardsHowItWorks = ({
  appStoreUrl,
  eventAnalytics,
  howItWorksConfig,
  matchMedia,
  urlPrefix,
}) => {
  const {
    title,
    disclaimer,
    steps = [],
  } = howItWorksConfig || {};

  const validSteps = steps.filter((step) => step.title);
  if (!title || validSteps.length === 0) return null;

  return (
    <section className="ResyRewardsHowItWorks">
      <div className="container">
        <div className="ResyRewardsHowItWorks__header">
          <h2
            className="ResyRewardsHowItWorks__title"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: sanitizeString(title) }}
          />
          <ResyRewardsAppStoreButton
            appStoreUrl={appStoreUrl}
            eventAnalytics={eventAnalytics}
            sectionName="How It Works"
          />
        </div>
        <ol className="ResyRewardsHowItWorks__steps">
          {validSteps.map((step, index) => (
            <li className="ResyRewardsHowItWorks__step" key={step.title}>
              <div className="ResyRewardsHowItWorks__step-content">
                <span className="ResyRewardsHowItWorks__step-number" aria-hidden="true">
                  {index + 1}
                </span>
                <h3
                  className="ResyRewardsHowItWorks__step-title"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: sanitizeString(step.title) }}
                />
                {step.copy && (
                  <p
                    className="ResyRewardsHowItWorks__step-copy"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: sanitizeString(step.copy) }}
                  />
                )}
              </div>
              {step.images && (
                <div className="ResyRewardsHowItWorks__step-image">
                  <AmexImage
                    images={step.images}
                    imageAlt={step.image_alt}
                    mediaBreakpoint={BREAKPOINTS.MEDIUM}
                    matchMedia={matchMedia}
                    urlPrefix={urlPrefix}
                  />
                  {step.overlay_image && (
                    <img
                      className="ResyRewardsHowItWorks__step-overlay"
                      src={`${urlPrefix}${step.overlay_image}`}
                      alt={step.overlay_alt || ''}
                    />
                  )}
                </div>
              )}
            </li>
          ))}
        </ol>
        {disclaimer && (
          <p
            className="ResyRewardsHowItWorks__disclaimer"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: sanitizeString(disclaimer) }}
          />
        )}
      </div>
    </section>
  );
};

ResyRewardsHowItWorks.propTypes = {
  appStoreUrl: PropTypes.string,
  eventAnalytics: PropTypes.func,
  howItWorksConfig: PropTypes.shape({
    title: PropTypes.string,
    disclaimer: PropTypes.string,
    steps: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      copy: PropTypes.string,
      image_alt: PropTypes.string,
      images: PropTypes.shape({
        desktop: PropTypes.string,
        mobile: PropTypes.string,
      }),
      overlay_image: PropTypes.string,
      overlay_alt: PropTypes.string,
    })),
  }),
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  urlPrefix: PropTypes.string.isRequired,
};

ResyRewardsHowItWorks.defaultProps = {
  appStoreUrl: '',
  eventAnalytics: null,
  howItWorksConfig: null,
};

export default ResyRewardsHowItWorks;
